<template>
	<div class="report-list">
		<CFullEmpty v-if="emptyData" class="empty-box" />
		<template v-else>
			<div v-for="(item, index) in tabData" :key="index" class="report-box" @click="handleReport(item)">
				<div class="report-tip">
					<img class="icon-svg" src="@/assets/images/irstore/icon-yanbao.svg" alt="" />
					<span class="tip-content">{{ $t('enterprise.research-report') }}</span>
					<span class="date font-Regular">{{ item.date }}</span>
				</div>
				<div class="report-title">{{ item.title }}</div>
				<div class="organization">
					<span>{{ item.orgName }}</span>
					<template v-if="item.rating">
						<span class="dot"> · </span>
						<div
							class="report-list__rate"
							:class="{ 'up': item.rateType === 1, 'down': item.rateType === 2 }"
						>
							{{ item.rating }}
						</div>
					</template>
				</div>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script>
import { irstore } from '@/fetch/interface';
import { isBuild } from '@/utils/const';
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import paginationMixin from '@/view/enterprise/mixins/paginationMixin';
import { mapGetters } from 'vuex';
import { getLanguageType } from '@/assets/js/i18n';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export default {
	components: {
		CFooterLoad,
		CFullEmpty
	},
	mixins: [paginationMixin],
	props: {
		storeData: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['getIrTemplateData', 'getIrFullCode'])
	},
	mounted() {
		// install mixins
		this.PAGINATION_LOAD = this.loadModule;
		this.PAGINATION_OBS_INSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.install();
		};
		this.PAGINATION_OBS_UNINSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.uninstall();
		};
	},
	methods: {
		loadMoreData() {
			this.PAGINATION_LOAD_MORE();
		},
		refreshModule(query) {
			if (!query.actionFilter.length) {
				return (this.emptyData = true);
			}
			this.PAGINATION_REFRESH(query);
		},
		loadModule() {
			return this.$axios
				.post(irstore.postReportList, {
					pagestart: this.pageStart,
					pagenum: 20,
					fullCode: this.getIrFullCode,
					rating: this.queryOptions.value || '',
					languageType: getLanguageType()
				})
				.then(res => {
					const result = (res?.rows || []).map((item, i) => {
						// 后端把字段名改了
						item.date = item.publishDate;

						if ((isBuild && item.reportId == 151614) || (!isBuild && item.reportId == 160248)) {
							item.date = '2021-06-07';
						}
						if ((isBuild && item.reportId == 157406) || (!isBuild && item.reportId == 157572)) {
							item.date = '2021-05-14';
						}

						return item;
					});
					this.PAGINATION_DATA_UPDATE(result);
					this.$emit('refresh');

					const total = res?.total || 0;
					const hasMore = this.tabData.length < total;
					return Promise.resolve(hasMore);
				})
				.catch(() => Promise.resolve(false));
		},
		handleReport(item) {
			this.viewModule('report', item);
		}
	},
	setup() {
		const { viewModule } = useModuleNavigation();
		return {
			viewModule
		};
	}
};
</script>

<style lang="less" scoped>
.report-list {
	background: #f7f7f7;

	.empty-box {
		padding: 0.2rem 0;
	}

	.report-box {
		padding: 0.125rem 0.12rem;
		background: #fff;

		& + .report-box {
			margin-top: 0.08rem;
		}
		.report-tip {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 0.12rem;
			line-height: 0.17rem;
			color: #333;
			.tip-content {
				margin-left: 0.08rem;
			}
			.date {
				margin-left: 0.08rem;
				font-size: 0.11rem;
				line-height: 0.15rem;
				color: #666;
			}
			.icon-svg {
				width: 0.16rem;
				height: 0.16rem;
			}
		}
		.report-title {
			margin: 0.1rem 0;
			font-size: 0.15rem;
			line-height: 0.24rem;
			letter-spacing: 1px;
			color: #333;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}
		.report-list__rate {
			font-size: 0.1rem;
			color: #5d667a;
			padding: 0 0.02rem;
			height: 0.16rem;
			line-height: 0.14rem;
			text-align: center;
			background: rgba(102, 102, 102, 0.1);
			border: 1px solid rgba(102, 102, 102, 0.2);
			border-radius: 2px;

			&.up {
				color: #ff8130;
				background: rgba(247, 106, 43, 0.1);
				border: 1px solid rgba(247, 106, 43, 0.2);
			}

			&.down {
				color: #30aa5b;
				background: rgba(48, 170, 91, 0.2);
				border: 1px solid rgba(48, 170, 91, 0.2);
			}
		}
		.organization {
			display: flex;
			font-size: 0.11rem;
			line-height: 0.15rem;
			color: #666;
			.dot {
				margin: 0 0.04rem;
			}
		}
	}
}
</style>
